import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"

import { cn } from "@/lib/utils"

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipContent = React.forwardRef(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        "z-50 overflow-hidden rounded-md bg-primary px-3 py-1.5 text-xs text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-tooltip-content-transform-origin]",
        className
      )}
      {...props} />
  </TooltipPrimitive.Portal>
))
TooltipContent.displayName = TooltipPrimitive.Content.displayName

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }


import { useState, useRef } from "react";

export const TooltipText = ({
  children,
  content,
  position = "top",
}) => {
  const [visible, setVisible] = useState(false);
  const timeoutRef = useRef();

  const show = () => {
    timeoutRef.current = setTimeout(() => setVisible(true), 150);
  };

  const hide = () => {
    clearTimeout(timeoutRef.current);
    setVisible(false);
  };

  const positionClasses = {
    top: "bottom-full left-1/2 -translate-x-1/2 mb-2",
    bottom: "top-full left-1/2 -translate-x-1/2 mt-2",
    left: "right-full top-1/2 -translate-y-1/2 mr-2",
    right: "left-full top-1/2 -translate-y-1/2 ml-2",
  };

  return (
    <div
      className="relative inline-block"
      onMouseEnter={show}
      onMouseLeave={hide}
    >
      {children}

      {content && <div
        className={`absolute z-50 px-2 py-1 text-center text-xs rounded shadow  transition-all duration-200 w-full max-w-[500px] min-w-[100px]
        ${positionClasses[position]}
        ${
          visible
            ? "opacity-100 scale-100"
            : "opacity-0 scale-95 pointer-events-none"
        }
        
        bg-gray-900 text-white
        dark:bg-gray-100 dark:text-gray-900
        `}
      >
        {content}

        {/* Arrow */}
      <div
  className={`
    absolute w-2 h-2 rotate-45
    bg-gray-900 dark:bg-gray-100

    ${position === "top" && "top-full left-1/2 -translate-x-1/2 -mt-1"}
    ${position === "bottom" && "bottom-full left-1/2 -translate-x-1/2 -mb-1"}
    ${position === "left" && "left-full top-1/2 -translate-y-1/2 -ml-1"}
    ${position === "right" && "right-full top-1/2 -translate-y-1/2 -mr-1"}
  `}
/>
      </div>}
    </div>
  );
};